<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import authenticate from "@/models/authenticate";
//import router from '../../index'
import { MethodsActionsLoginManisa } from "@/state/helpers";
import Vue from 'vue'
import axios from "axios";
import yukleniyor from "../FormComponet/loader.vue";
import moment from "moment";

export default {
  mixins: [apibtoast, apigeneric, authenticate],
  page: {
    title: "Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {

    yukleniyor,
  },
  data() {
    return {
      loading:1,
      loadingnew: false,
      FormData: {},
      FormData2: {},
      ErrorMessage: "",
      benihatirla: "false",
      loginbutton: false,
      email: "admin@themesbrand.com",
      guid: null,
      password: "123456",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      formbuttons: false,
      sifre_sifirla: false,
      images: ["https://cdn.pixabay.com/photo/2013/02/26/01/10/auditorium-86197_960_720.jpg", "https://cdn.pixabay.com/photo/2017/07/15/21/06/reception-2507752_960_720.jpg", "https://cdn.pixabay.com/photo/2016/01/05/11/36/architecture-1122359_960_720.jpg"],
      timer: null,
      DataId: this.$route.params.data,
      AuthData: null,
      currentURL: window.location.href,
      currentIndex: 0,
      KurumAdi: this.$config.KURUM_ADI,
      UygulamaAdi: this.$config.UYGULAMA_ADI,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      sms_dogrulama:this.$config.SMS_DOGRULAMA,
      sms_telefon:null,
      Senddate:null,
      Verifycode:null,
      OSmsVerificationPostSonucu:null,
      SetJWToken:null,
      SetAuth:null
    };
  },
  computed: {
    currentImg: function () {
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    },
  },
  methods: {
    ...MethodsActionsLoginManisa,
    Get() {
      //get 
    },
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
    },
    Login() {
 this.OSmsVerificationPostSonucu=null;
      this.loading=0;
      this.loadingnew=true;

      this.ErrorMessage = "";
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loginbutton = true;
        
        
            this.ActionsLogin(this.FormData).then((res) => {

               if (res.data.Succeeded == true) {

                this.SetJWToken = res.data.Data.JWToken;
                this.SetAuth = res.data.Data;
                
                const phone = res.data.Data.PhoneNumber;

                if (this.sms_dogrulama == true) {

                  this.sms_telefon = phone;

                  this.Senddate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";

                  const smsData = {
                    Recipientphone: this.sms_telefon,
                    Senddate: this.Senddate
                  };


                      axios.post(this.$config.API_URL+"OSmsVerification", smsData, {
                          headers: {
                            Authorization: 'Bearer '+res.data.Data.JWToken,
                            "Content-Type": "application/json"
                          }
                        }).then((smsRes) => {
                       
                                  if (smsRes) {
                                    this.OSmsVerificationPostSonucu = smsRes;

                                  }
                                });

                } else {
                       this.$store.commit("auth/SetJWToken", this.SetJWToken);
                      this.$store.commit("auth/SetAuth", this.SetAuth);

                    setTimeout(() => {
                        window.location.href = "/";
                    }, 500);

                  window.location.href = "/";
                }
              }
            });
      }
    },

OSmsVerificationSorgu() {
  axios.get(this.$config.API_URL + "OSmsVerification", {
    headers: {
      Authorization: "Bearer " + this.SetJWToken,
      "Content-Type": "application/json"
    },
    params: {
      Recipientphone: this.sms_telefon,
      Senddate: this.Senddate,
      Verifycode: this.Verifycode
    }
  }).then((res) => {
    // 1. Kodun doğruluğunu kontrol et
    if (
        res &&
        res.data.Data &&
        res.data.Data.length > 0 &&
        res.data.Data[0].Verifycode == this.Verifycode
      ) {
        
        this.$store.commit("auth/SetJWToken", this.SetJWToken);
        this.$store.commit("auth/SetAuth", this.SetAuth);
        
        this.$toast.success("SMS Doğrulama Başarılı");


        setTimeout(() => {
           window.location.href = "/";
        }, 500);

      } else {
        this.$toast.error("Kod hatalı!");
      }
  });
},

    generateGUID() {
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 21 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(21);
      });
    },
    generateRandomNumber() {
      var min = 1000000000; // En küçük 10 haneli sayı
      var max = 9999999999; // En büyük 10 haneli sayı
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // Slider İçin Retikleyiciler
    startSlide: function () {
      this.timer = setInterval(this.next, 7000);
    },
    next: function () {
      if (this.currentIndex == this.images.length - 1) {
        this.currentIndex = -1;
      }
      this.currentIndex += 1;
    },
    getQueryParam(url, param) {
      var params = new URLSearchParams(new URL(url).search);
      return params.get(param);
    },
    loginbuttonclick(){
      this.loginbutton = false;
    },
    getData() {
      if (this.currentURL != 'https://login.cbu.edu.tr/login') {
        var equalsIndex = this.currentURL.indexOf('=');
        if (equalsIndex !== -1) {
          var result = this.currentURL.slice(equalsIndex + 1);
        } else {
          console.log("Metinde '=' karakteri bulunamadı.");
        }

        const veri = {
          data: result

        };
        this.AuthData = result;
        if (this.AuthData != null) {
          axios.post(Vue.prototype.$config.API_ACCOUNT_URL + 'Account/SAMLRequest', null, {
            params: veri, // Query dizesi olarak göndermek istediğiniz veri
          })
            .then((res) => {

              if (res.data.Succeeded == true) {

                let Data = {
                  JWToken: res.data.Data.JWToken,
                  Data: res.data.Data
                }
                this.ActionsLoginManisa(Data).then((res) => {
                  if (res == true) {
                    window.location.href = "/";
                  } else {
                    window.location = this.$config.LOGIN_URL
                  }
                });

              } else {
                return false;
              }
            })
            .catch((error) => error.response.data)
            .catch((error) => {
              console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
            });

        }
      }


    }
  },

  mounted() {
    this.startSlide();
    this.FormData = this.authenticateData;
    if (window.$cookies.get("ecampususer")) {
      this.benihatirla = true;
      var cookies = window.$cookies.get("ecampususer");
      cookies = this.$CryptoJS.AES.decrypt(cookies, process.env.VUE_APP_SHA_KEY).toString(this.CryptoJS.enc.Utf8);
      this.FormData = JSON.parse(cookies);
    }
    this.getData();

  },
  created() {

  }


};
</script>

<template>
  <div>
    <div class="slider-bg"
      :style="{ backgroundImage: 'linear-gradient(180deg, rgba(0,131,168,0.77) 0%, rgba(0,0,0,0.46) 100%), url(\'' + images[currentIndex] + '\')' }">
      <div class="slider">
        <div class="slider-title">
          <h1>{{ KurumAdi }}</h1>
          <!--    <h1>
            {{ $t("login.page.slogan") }} <br />
            {{ $t("login.page.slogan2") }}
          </h1>
          <h4>{{ $t("login.page.hosgeldinmesaj") }}</h4>  -->
        </div>
        <div class="copy"> Elasoft Yazılım Bilişim Teknolojileri</div>
      </div>

      <div v-if="!OSmsVerificationPostSonucu" class="login-form-container">
        <div class="logo mb-4">
          <img src="/assets/images/Kurum_Logo2.png" width="180px" />
          <div class="title mt-5">
            <h2>{{ KurumAdi }}</h2>
            <p>{{ UygulamaAdi }}  {{ $t("login.page.uygulamadi2") }}</p>
          </div>
        </div>
        
        <div class="container-login-from mb-4">
          <b-form class="p-0" >
            <div class="row">
              <div class="col-12 mt-2">
                <b-button  variant="primary" class="btn-block login-btn"  @click="formbuttons = !formbuttons" v-if="formbuttons == false">{{
              $t("login.page.giris") }} Yap</b-button>
              </div>
    <!--      <div :class="formbuttons == false ? 'col-6' : 'col-12'">
            <b-button href="http://routesaml.cbu.edu.tr/Home/Login" variant="primary"
              class="btn-block login-btn">MCBU Bilgileri İle Giriş Yap</b-button>
            </div> -->
            </div>
          </b-form>
        </div>

        <div class="container-login-from mb-4" v-if="!sifre_sifirla && formbuttons == true">
          <b-form class="p-0" @submit.prevent="Login">
            <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
              <b-form-input id="input-1" class="form-control" v-model="FormData.Email" type="text"
                :placeholder="$t('login.page.kullaniciadi')"
                :class="{ 'is-invalid': submitted && $v.FormData.Email.$error }"></b-form-input>
              <div v-if="submitted && $v.FormData.Email.$error" class="invalid-feedback">
                <span v-if="!$v.FormData.Email.required">{{ $t("login.page.requirederror") }}</span>
                <span v-if="!$v.FormData.Email.email">{{ $t("login.page.emailerror") }}</span>
              </div>
            </b-form-group>
            <b-form-group class="mb-3" id="input-group-2" label-for="input-2">
              <b-form-input id="input-2" class="form-control" v-model="FormData.Password" type="password"
                :placeholder="$t('login.page.parola')" :class="{
                  'is-invalid': submitted && $v.FormData.Password.$error,
                }"></b-form-input>
              <div v-if="submitted && !$v.FormData.Password.required" class="invalid-feedback">
                {{ $t("login.page.requirederror") }}
              </div>
            </b-form-group>

            <div class="title mt-3">
              <p class="erormesssage">{{ ErrorMessage }}</p>
            </div>

            <b-form-checkbox class="form-check" value="true" unchecked-value="false" v-model="benihatirla">
              {{ $t("login.page.benihatirla") }}
            </b-form-checkbox>
            <b-button :disabled="loginbutton == true" type="submit" variant="primary" class="btn-block login-btn">{{
              $t("login.page.giris") }}</b-button>
          </b-form>
          <!-- <div class="mt-4 text-left">
            <a class="text-muted" @click="sifre_sifirla = !sifre_sifirla">
              <i class="mdi mdi-lock me-1"></i>
              {{ $t("login.page.sifremiunuttum") }}
            </a>
          </div>-->
        </div>

        <div class="container-login-from mb-4" v-if="sifre_sifirla">
          <div class="text-white">
            <h5 class="text-white">{{ $t("login.page.parolasifirlama") }}</h5>
            <p>{{ $t("login.page.asagidakiformueksiksizdoldurun") }}</p>
          </div>
          <b-form class="p-0" @submit.prevent="tryToLogIn">
            <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
              <b-form-input id="input-1" class="form-control" v-model="FormData.Email" type="text"
                :placeholder="$t('login.page.kullaniciadi')"></b-form-input>
              <div v-if="submitted && $v.FormData.Email.$error" class="invalid-feedback">
                <span v-if="!$v.FormData.Email.required">{{ $t("login.page.requirederror") }}</span>
                <span v-if="!$v.FormData.Email.email">{{ $t("login.page.emailerror") }}</span>
              </div>
            </b-form-group>
            <b-form-group class="mb-3" id="input-group-2" label-for="input-2">
              <b-form-input id="input-2" class="form-control" v-model="password" type="text"
                :placeholder="$t('login.page.tckimlikno')"></b-form-input>
              <div v-if="submitted && !$v.FormData.Password.required" class="invalid-feedback">
                {{ $t("login.page.requirederror") }}
              </div>
            </b-form-group>

            <b-button type="submit" variant="primary" class="btn-block login-btn">{{ $t("login.page.sifremisifirla")
            }}</b-button>
          </b-form>
        </div>
        <!--
        <div class="text-notfy mb-4">
          <p>{{ $t("login.page.logincontent") }}</p>
        </div>
        <div class="pasw-task">
          <router-link tag="a" to="/forgot-password" class="text-muted new-pasw">
            {{ $t("login.page.yenisifreolustur") }}
          </router-link>
          <router-link tag="a" to="/forgot-password" class="text-muted">
            {{ $t("login.page.epostaadresimiogrenmekistiyorum") }}
          </router-link>
          <router-link tag="a" to="/forgot-password" class="text-muted">
            {{ $t("login.page.ogrencinumaramiogrenmekistiyorum") }}
          </router-link>
        </div>-->
      </div>



<div  class="login-form-container" v-if="OSmsVerificationPostSonucu">

  <div class="text-white">
    <h5>SMS Doğrulama</h5>
    <p>Telefonunuza gelen kodu giriniz</p>
  </div>

  <b-form>

    <b-form-group class="mb-3">
      <b-form-input
        v-model="Verifycode"
        type="text"
        placeholder="Doğrulama Kodu">
      </b-form-input>
    </b-form-group>

    <b-button  variant="success" @click="OSmsVerificationSorgu" class="btn-block">
      Doğrula
    </b-button>

  </b-form>

      </div>


    </div>



  <div v-if="loading == 0" class="loading-overlay">
        <yukleniyor></yukleniyor>
      </div>


  </div>



</template>

<style scoped>
.erormesssage {
  color: aliceblue;
}

.logo {
  line-height: 0px;
}

.slider {
  display: inline-flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
}

.copy {
  margin-top: auto;
  margin-bottom: 40px;
  margin-left: 40px;
  font-size: 10px;
  font-weight: 300;
  color: aliceblue;
}

.slider-title {
  align-self: center;
  margin-top: auto;
  margin-left: 40px;
  padding-left: 10px;
  border-left: 4px solid #113a64;
}

.slider-title h1,
.slider-title h4 {
  color: aliceblue;
}

.slider-title h4 {
  font-weight: 300;
  font-size: 16px;
}

.slider-title h1 {
  font-weight: 700;
}

.slider-bg {
  width: 100vw !important;
  height: 100vh !important;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.login-form-container {
  padding: 36px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 400px;
  height: 100vh;
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  backdrop-filter: contrast(40%) blur(5px);
  border-radius: 22px 0px 0px 22px;
  background: rgba(0, 0, 0, 0.19);
}

.login-form-container::-webkit-scrollbar {
  display: none;
}

.pasw-task a {
  display: block;
  font-size: 12px;
  padding: 2.5px 0px;
  font-weight: 300;
}

.pasw-task a.new-pasw {
  font-size: 16px;
  font-weight: 400;
}

.title,
.title h2 {
  color: aliceblue;
}

.text-notfy {
  color: aliceblue;
  font-size: 12px;
  font-weight: 300;
}

.form-control {
  background: none;
  border-radius: 6px;
  color: aliceblue;
}

.form-control::placeholder {
  color: aliceblue;
}

.form-control:focus {
  color: rgb(246, 243, 243);
}

.form-check {
  color: aliceblue;
}

.login-btn {
  width: 100%;
  background-color: #262b3c !important;
  border: none;
}

.login-btn:hover {
  background-color: #0083a8 !important;
}

.text-muted {
  color: aliceblue !important;
}

.text-muted:hover {
  color: #ffc652 !important;
}

.is-invalid,
.invalid-feedback {
  color: #ffb1b1 !important;
  border-color: #ffadad !important;
}

/* ----------- Retina Screens ----------- */

@media (max-width: 792px) {
  .slider {
    display: none;
  }

  .login-form-container {
    width: 100%;
  }

  .login-form-container {
    border-radius: 0px 0px 0px 0px;
  }
}</style>
